export const quranFr = {
  landing: {
    badge: 'Le Coran est désormais ouvert à tous',
    titleLine1: 'Le Coran, pour tous.',
    titleGradient: 'Lire. Écouter. Étudier.',
    subtitle:
      'Le Coran entier en arabe, avec sa traduction en français, allemand, néerlandais, anglais et bosniaque. Gratuit, sans inscription, sur tous tes appareils. Cherche un mot, compte-le dans tout le Coran et écoute verset par verset.',
    appNote: 'Pour le hifz avec l’IA, l’audio hors ligne et les horaires de prière, télécharge l’application.',
    daily: 'Verset du jour',
    listen: 'Écouter',
    study: 'Étudier ce verset',
    studyEyebrow: 'Le Coran sur Deenly',
    studyTitle: 'Ne te contente pas de lire. Étudie.',
    studySubtitle: 'Des outils pour comprendre ce que tu lis, gratuits pour tous.',
    cards: [
      { to: '/quran/', icon: 'solar:book-2-linear', title: 'Lire et écouter', body: 'Les 114 sourates, le texte arabe et ses traductions en cinq langues, six récitateurs. Le lecteur suit le verset récité, même depuis l’écran verrouillé.', cta: 'Ouvrir le Coran' },
      { to: '/quran/tafsir/', icon: 'solar:notebook-bookmark-linear', title: 'Le tafsir de chaque verset', body: 'Que signifie un verset ? Une explication des 6 236 versets tirée d’Al-Mukhtasar, en français, en anglais, en bosniaque et dans l’original arabe, avec sa source et une référence à citer.', cta: 'Ouvrir le tafsir' },
      { to: '/quran/search/', icon: 'solar:magnifer-linear', title: 'Chercher par mot ou par sens', body: 'Trouve un verset grâce à un mot, au nom d’une sourate ou à une référence comme 2:255. Ou décris un thème et l’IA trouve les versets par leur sens.', cta: 'Chercher dans le Coran' },
      { to: '/quran/2/255/', icon: 'solar:square-academic-cap-linear', title: 'Mot à mot', body: 'Touche n’importe quel mot arabe : sa racine, sa grammaire et sa fréquence dans le Coran. À partir de la racine, suis une même idée à travers tout le Coran.', cta: 'Essayer sur Ayat al-Kursi' },
    ],
  },
  nav: {
    home: 'Accueil Deenly',
    quran: 'Coran',
    label: 'Navigation du Coran',
    read: 'Lire',
    search: 'Rechercher',
    words: 'Le Coran en chiffres',
    tafsir: 'Tafsir',
    roots: 'Racines',
    chronology: 'Chronologie',
    switchLanguage: 'Changer de langue',
  },
  common: {
    close: 'Fermer',
    error: 'Une erreur s’est produite. Réessaie dans un instant.',
    notFound: 'Ce verset n’existe pas.',
    breadcrumbs: 'Fil d’Ariane',
    pagination: 'Précédent et suivant',
    loadMore: 'En voir plus',
  },
  translation: {
    de: 'Allemand · Bubenheim & Elyas',
    nl: 'Néerlandais · Rowwad Translation Center',
    fr: 'Français · Rachid Maach',
    bs: 'Bosniaque · Besim Korkut',
    en: 'Anglais · Saheeh International',
  },
  quick: {
    label: 'Les plus lus',
    ayatulKursi: 'Ayat al-Kursi',
    lastOfBaqarah: 'Fin d’Al-Baqarah',
  },
  index: {
    badge: 'Ouvert à tous · gratuit · sans inscription',
    title: 'Le Coran, pour tous',
    subtitle:
      'Les 114 sourates en arabe, avec leur traduction en français, allemand, néerlandais, anglais et bosniaque. Écoute verset par verset, cherche par mot ou par sens, et étudie chaque mot.',
    stats: [
      { label: 'Sourates', value: '114' },
      { label: 'Versets', value: '6 236' },
      { label: 'Langues', value: '6' },
      { label: 'Récitateurs', value: '6' },
    ],
    wordsTitle: 'Combien de fois le Coran dit-il… ?',
    wordsBody:
      'Tape n’importe quel mot (en français, en arabe, en anglais ou en bosniaque) et vois en une seconde combien de fois il revient, dans quelles sourates et quels versets. Compare deux mots et découvre le Coran sous un nouvel angle.',
    wordsCta: 'Ouvrir Le Coran en chiffres',
    surahsTitle: 'Toutes les sourates',
    surahsSubtitle: 'Trouve-en une par son nom, son sens ou son numéro.',
    filterLabel: 'Filtrer les sourates',
    filterPlaceholder: 'ex. Yasin, La Caverne, 18…',
    filterRevelation: 'Lieu de la révélation',
    filterAll: 'Toutes',
    noMatch: 'Aucune sourate ne correspond.',
  },
  surah: {
    meccan: 'Mecquoise',
    medinan: 'Médinoise',
    ayahCount: '{n} verset | {n} versets',
    juz: 'Juz {n}',
    listen: 'Écouter la sourate',
    previous: 'Sourate précédente',
    next: 'Sourate suivante',
  },
  ayah: {
    actions: 'Actions pour {ref}',
    listen: 'Écouter {ref}',
    copy: 'Copier le verset',
    save: 'Enregistrer dans ma salle d’étude',
    saved: 'Enregistré dans ta collection',
    copied: 'Copié',
    share: 'Partager',
    study: 'Étudier {ref}',
    sajdah: 'Sajda',
  },
  ayahPage: {
    eyebrow: 'Verset',
    inContext: 'Lire dans son contexte',
    listenOn: 'Écouter à partir d’ici',
    previous: 'Verset précédent',
    next: 'Verset suivant',
    wordsTitle: 'Mot à mot',
    wordsHint: 'Chaque mot du verset, avec sa prononciation et son sens. Touche un mot pour voir combien de fois il revient dans le Coran.',
    wordsSource: 'Prononciation et sens des mots : Quran.com.',
    wordsSourceBs: 'Prononciation et sens des mots : Quran.com.',
    relatedTitle: 'Versets liés',
    relatedHint: 'D’autres versets du Coran qui abordent le même thème.',
    aboutSurah: 'À propos de cette sourate',
  },
  settings: {
    title: 'Réglages',
    translation: 'Traduction',
    both: 'Les deux',
    none: 'Aucune',
    arabicFont: 'Écriture arabe',
    arabicSize: 'Taille du texte arabe',
    sizeStep: 'Taille {n}',
    wordStudy: 'Étude des mots',
    wordStudyHint: 'Touche un mot arabe pour voir combien de fois il revient dans le Coran.',
  },
  player: {
    label: 'Lecteur du Coran',
    play: 'Lecture',
    pause: 'Pause',
    previous: 'Verset précédent',
    next: 'Verset suivant',
    stop: 'Arrêter et fermer',
    expand: 'Ouvrir le lecteur',
    collapse: 'Réduire le lecteur',
    nowPlaying: 'Récitation en cours',
    openSurah: 'Ouvrir la sourate',
    seek: 'Position dans le verset',
    failed: 'L’audio n’a pas pu se charger. Vérifie ta connexion et réessaie.',
    reciter: 'Récitateur',
    repeatAll: 'Tout répéter',
    ayahRepeat: 'Répéter chaque verset : {n}',
    repeatRound: 'répétition {n}',
    volume: 'Volume',
    sleep: 'Minuteur de sommeil',
    sleepMinutes: 'Dans {n} minutes',
    sleepEnd: 'À la fin de la sourate',
    sleepOff: 'Désactiver le minuteur',
    tabText: 'Texte',
    ayahOf: 'verset {ayah} sur {total}',
    backToCurrent: 'Revenir au verset récité',
    speed: 'Vitesse',
    follow: 'Suivre la récitation',
    followHint: 'Pendant la lecture d’une sourate, la page défile toute seule jusqu’au verset récité et le met en évidence.',
  },
  peek: {
    title: 'Le mot {word} dans le Coran',
    eyebrow: 'Ce mot dans le Coran',
    exact: 'Exactement cette forme',
    inside: 'À l’intérieur d’autres mots',
    spread: 'Dans {ayahs} versets, répartis sur {surahs} sourates.',
    open: 'Toutes les occurrences',
  },
  tafsir: {
    nav: 'Tafsir',
    cta: 'Ouvrir le tafsir',
    teaser: 'Que signifie un verset ? Une explication de chaque verset tirée d’Al-Mukhtasar, en français, en anglais, en bosniaque et dans l’original arabe, avec sa source et une référence à citer pour tes études.',
    eyebrow: 'Expliquer le Coran',
    title: 'Le tafsir du Coran',
    intro:
      'Une explication de chacun des 6 236 versets, tirée d’Al-Mukhtasar, en français, en anglais, en bosniaque et dans l’original arabe. Lis le tafsir sourate par sourate, compare-le avec l’original et cherche ce qui est dit sur n’importe quel thème.',
    facts: { ayahs: 'versets expliqués', langs: 'langues : français, anglais, néerlandais, bosniaque, arabe', surahs: 'sourates' },
    surahsTitle: 'Le tafsir par sourate',
    surahsHint: 'Choisis une sourate : chaque verset en arabe, avec sa traduction et l’explication juste en dessous.',
    aboutTitle: 'À propos d’Al-Mukhtasar',
    about: [
      'Al-Mukhtasar dans l’interprétation du Noble Coran a été préparé par le Centre de Tafsir pour les études coraniques. Chaque verset y est expliqué de façon brève et claire, sans longues digressions, ce qui convient aussi bien à la lecture quotidienne qu’à une étude approfondie.',
      'L’ouvrage a été rédigé en arabe ; les textes français, anglais et bosniaque sont des traductions de cet original. C’est pourquoi chaque verset te permet d’ouvrir l’original arabe et de le comparer avec la traduction.',
    ],
    methodTitle: 'Comment il est publié ici',
    method: [
      'Le texte est publié tel que la source le diffuse, sans modification ni coupure.',
      'Chaque texte indique son titre, son auteur, son édition et sa date de récupération, et le bouton « Citer » donne une référence prête à l’emploi avec un lien.',
      'Le tafsir est tenu à jour avec la dernière version publiée par QuranEnc.com.',
    ],
    langLabel: 'Langue du tafsir',
    langs: { bs: 'Bosanski', en: 'English', fr: 'Français', nl: 'Nederlands', ar: 'العربية' },
    sameAs: 'Voir l’explication du verset {n}.',
    retold: 'Une reformulation moderne fondée sur les savants classiques, pas une traduction littérale',
    translationOf: 'Traduit de l’original arabe',
    original: 'Original arabe',
    label: 'Tafsir',
    ayahTitle: 'Le tafsir de ce verset',
    ayahHint: 'Ce que signifie ce verset : l’explication d’Al-Mukhtasar.',
    wholeSurah: 'Le tafsir de toute la sourate',
    readSurah: 'Lire la sourate',
    show: 'Tafsir',
    hide: 'Masquer le tafsir',
    toggle: 'Tafsir de {ref}',
    inReader: 'Le tafsir sous chaque verset',
    inReaderHint: 'Une courte explication sous chaque verset. Le bouton « Tafsir » d’un verset l’ouvre un par un.',
    showAyah: 'Verset et traduction',
    ayahIndex: 'Versets',
    goToAyah: 'Aller au verset {n}',
    source: 'Source',
    sourceLine: '{title} — {author}. {publisher}, édition « {edition} », récupéré le {date}.',
    cite: 'Citer',
    cited: 'Référence copiée',
    refAyah: 'du verset {key}',
    refSurah: 'de la sourate {name}',
    citation: '{title} ({author}), explication {ref}. {publisher}, édition « {edition} », récupéré le {date}. {url}',
    unavailable: 'Le tafsir n’est pas encore disponible dans cette langue.',
    searchTitle: 'Chercher dans le tafsir',
    searchLabel: 'Chercher dans le tafsir',
    searchPlaceholder: 'Un thème ou un mot, ex. patience, parents, Jour du Jugement',
    searchHint: 'La recherche porte sur les explications, pas seulement sur les versets : découvre ce que dit le tafsir sur un thème.',
    resultCount: 'Aucun verset n’a « {q} » dans son tafsir | {n} verset a « {q} » dans son tafsir | {n} versets ont « {q} » dans leur tafsir',
    previous: 'Sourate précédente',
    next: 'Sourate suivante',
  },
  opinions: {
    title: "Ce qu'ont dit les savants",
    searchHint: "Réponses de savants de Ahl as-Sunnah, trouvées par les mots et par le sens, chacune avec un lien vers sa source.",
    ayahHint: "Réponses qui citent ce verset.",
    none: "Aucune réponse trouvée.",
    scholars: "Savants",
    citedAyat: "Versets cités :",
    source: "Lire à la source : {source}",
    inLanguage: "Disponible en : {language}",
  },
  search: {
    title: 'Chercher dans le Coran',
    label: 'Chercher dans le Coran',
    placeholder: 'Un mot, une sourate ou un verset (ex. miséricorde, Yasin, 2:255)',
    submit: 'Rechercher',
    suggestions: 'Suggestions',
    jump: 'Aller au verset {ref}',
    allResults: 'Tous les résultats pour « {q} »',
    countWord: 'Combien de fois « {q} » est-il mentionné ?',
    modeLabel: 'Mode de recherche',
    byWords: 'Par mots',
    byMeaning: 'Par sens',
    byScholars: "Savants",
    byTafsir: 'Dans le tafsir',
    meaningHint: 'Décris un thème avec tes propres mots, ex. « versets sur la patience dans l’épreuve ». L’IA trouve les versets par leur sens, pas par mot-clé.',
    meaningTooShort: 'Tape au moins trois lettres.',
    meaningError: 'La recherche par sens n’est pas disponible pour le moment. Essaie la recherche par mots.',
    resultCount: 'Aucun verset pour « {q} » | {n} verset pour « {q} » | {n} versets pour « {q} »',
    took: '{ms} ms',
    aiLabel: 'Intelligence artificielle',
    aiWorking: 'L’IA cherche dans le Coran par le sens…',
    aiFound: 'L’IA n’a trouvé aucun verset pour cette question | L’IA a trouvé {n} verset par le sens | L’IA a trouvé {n} versets par le sens',
    emptyTitle: 'Ce que tu peux chercher',
    tips: [
      'Un mot en français, anglais, bosniaque ou arabe : miséricorde, mercy, milost, رحمة',
      'Le nom d’une sourate : Kahf, Yasin, Rahman',
      'Un verset précis : 2:255 ou 36 1',
      'Un thème par le sens : passe sur « Par sens »',
    ],
  },
  words: {
    title: 'Le Coran en chiffres',
    subtitle:
      'Combien de fois un mot revient-il dans le Coran, dans quelles sourates, mecquoises ou médinoises ? Tape un mot, ou compare-en deux, en un clic.',
    tryOne: 'Essaie un exemple :',
    examples: 'Exemples',
    inputLabel: 'Mot à compter',
    placeholder: 'Un mot (ex. mercy, الله, milost)',
    compareLabel: 'Mot à comparer',
    comparePlaceholder: 'Un second mot à comparer',
    wordA: 'Premier mot',
    wordB: 'Second mot',
    addCompare: 'Comparer avec un autre mot',
    removeCompare: 'Retirer la comparaison',
    count: 'Compter',
    langLabel: 'Langue du texte',
    langBs: 'Bosniaque',
    langEn: 'Anglais',
    arabicDetected: 'Comptage dans le texte arabe',
    modeLabel: 'Comment un mot est reconnu',
    modeWord: 'Mot entier',
    modePrefix: 'Commence par',
    modeContains: 'Contient',
    modeHint: {
      word: 'Compte exactement ce mot : « day » ne compte pas « days ».',
      prefix: 'Compte tous les mots qui commencent ainsi : « merc » compte mercy, merciful, mercies…',
      contains: 'Compte les mots qui le contiennent : l’arabe « الله » compte aussi « والله », « بالله »…',
    },
    occurrences: '{n} fois | {n} fois',
    inAyahs: 'dans {ayahs} versets, {surahs} sourates',
    revelationSplit: 'Sourates mecquoises {meccan} %, médinoises {medinan} %',
    firstSeen: 'Première',
    lastSeen: 'Dernière',
    topSurahs: 'Le plus souvent dans',
    equal: '« {a} » et « {b} » sont mentionnés autant l’un que l’autre, {n} fois chacun.',
    nearlyEqual: '« {a} » et « {b} » sont mentionnés presque autant l’un que l’autre : {x} et {y} fois.',
    ratio: '« {more} » est mentionné {ratio}× plus souvent que « {less} ».',
    chartTitle: 'À travers les 114 sourates',
    chartHint: 'Une colonne par sourate, dans l’ordre du mushaf. Clique sur l’une d’elles pour les détails.',
    chartLabel: 'Occurrences par sourate',
    chartCaption: 'Histogramme : une colonne pour chacune des 114 sourates ; la hauteur indique le nombre d’occurrences.',
    openSurah: 'Ouvrir la sourate',
    noneTitle: 'Aucune occurrence',
    noneBody: 'Les traductions expriment souvent la même idée avec d’autres mots. Essaie « Commence par » ou « Contient », un synonyme ou le mot arabe, car c’est le texte arabe qui fait foi.',
    ayahsTitle: 'Versets',
    method:
      'Nous comptons les formes des mots dans le texte, sans les voyelles. C’est le texte arabe qui fait foi ; les traductions emploient des mots différents pour une même idée, leurs décomptes diffèrent donc de l’arabe.',
  },
  grammar: {
    title: 'Grammaire',
    root: 'Racine',
    lemma: 'Forme du dictionnaire',
    parts: 'Parties du mot',
    noRoot: 'Les particules et les pronoms n’ont pas de racine.',
    rootCount: '{n}× dans le Coran',
    allOfRoot: 'Tous les mots de cette racine',
    person: '{n}e personne',
    gender: { M: 'masculin', F: 'féminin' },
    number: { S: 'singulier', D: 'duel', P: 'pluriel' },
    form: 'forme verbale {n}',
    passive: 'passif',
    definite: 'défini (avec ٱل)',
    indefinite: 'indéfini',
    family: 'de la famille de « {word} »',
    tense: { PERF: 'accompli (passé)', IMPF: 'inaccompli (présent/futur)', IMPV: 'impératif' },
    case: { NOM: 'nominatif', ACC: 'accusatif', GEN: 'génitif' },
    mood: { IND: 'indicatif', SUBJ: 'subjonctif', JUS: 'jussif' },
    class: {
      V: 'verbe',
      N: 'nom',
      PN: 'nom propre',
      ADJ: 'adjectif',
      ACT_PCPL: 'participe actif',
      PASS_PCPL: 'participe passif',
      VN: 'nom verbal (masdar)',
      PRON: 'pronom',
      DEM: 'pronom démonstratif',
      REL: 'pronom relatif',
      T: 'adverbe de temps',
      LOC: 'adverbe de lieu',
      NV: 'interjection verbale',
      P: 'particule',
    },
    particle: {
      DET: 'article défini',
      CONJ: 'conjonction',
      REM: 'particule de reprise',
      P: 'préposition',
      NEG: 'particule de négation',
      EMPH: 'particule d’insistance',
      INTG: 'particule interrogative',
      VOC: 'particule vocative',
      FUT: 'particule du futur',
      CERT: 'particule de certitude',
      RSLT: 'particule de résultat',
      CAUS: 'particule de cause',
      SUB: 'conjonction de subordination',
      COND: 'particule conditionnelle',
      RES: 'particule de restriction',
      PRP: 'particule de but',
      CIRC: 'particule circonstancielle',
      EXP: 'particule d’exception',
      PREV: 'particule d’empêchement',
      PRO: 'particule d’interdiction',
      RET: 'particule de rétractation',
      SUP: 'particule supplétive',
      SUR: 'particule de surprise',
      EXH: 'particule d’exhortation',
      EXL: 'particule d’explication',
      EQ: 'particule d’équivalence',
      AMD: 'particule de correction',
      ANS: 'particule de réponse',
      AVR: 'particule d’aversion',
      COM: 'particule d’accompagnement',
      INC: 'particule inchoative',
      INT: 'particule d’interprétation',
      INL: 'initiales coraniques',
      ATT: 'particule d’attention',
      DIST: 'marque d’éloignement',
      ADDR: 'marque du destinataire',
      ACC: 'particule accusative',
    },
  },
  roots: {
    nav: 'Racines',
    eyebrow: 'Le vocabulaire du Coran',
    title: 'Les racines des mots du Coran',
    subtitle:
      'Presque tous les mots arabes naissent d’une racine de trois ou quatre lettres : la racine صبر donne patience, patient et être patient. Choisis une racine et suis une même idée à travers tout le Coran.',
    factRoots: 'racines',
    factLemmas: 'formes du dictionnaire',
    factWords: 'mots avec leur grammaire',
    lettersLabel: 'Racines par première lettre',
    searchLabel: 'Chercher dans les racines',
    searchPlaceholder: 'Une racine ou un sens (ex. رحم, savoir, miséricorde)',
    count: '{n} racines',
    showing: '{shown} sur {total} affichées',
    none: 'Aucune racine ne correspond à ta recherche.',
    showMore: 'En voir plus',
    sortLabel: 'Trier',
    sortFrequent: 'Les plus fréquentes',
    sortAlpha: 'Par ordre alphabétique',
    occurrences: '{n}× dans le Coran',
    words: '{n} mot | {n} mots',
    pageTitle: 'La racine {root}',
    pageSubtitle: 'Tous les mots formés à partir de cette racine, leur place dans le Coran et tous les versets où ils apparaissent.',
    lemmasTitle: 'Les mots de cette racine',
    lemmasHint: 'Clique sur un mot pour ne voir que ses versets.',
    allLemmas: 'Tous les mots',
    lemmaCol: 'Mot',
    classCol: 'Nature',
    meaningCol: 'Sens',
    countCol: 'Fois',
    filtered: 'Affichage limité à : {lemma}',
    clearFilter: 'Afficher toute la racine',
    chartTitle: 'À travers les 114 sourates',
    ayahsTitle: 'Versets',
    back: 'Toutes les racines',
    notFound: 'Cette racine n’apparaît pas dans le Coran.',
    whatTitle: 'Qu’est-ce qu’une racine ?',
    whatBody:
      'En arabe, le sens se trouve dans la racine, le plus souvent trois consonnes, et les voyelles et les ajouts construisent les mots autour d’elle. La racine كتب donne kataba (il a écrit), kitāb (livre), kātib (scribe) et maktūb (écrit). Suivre une racine montre comment le Coran déploie une même idée à travers de nombreux mots.',
    methodTitle: 'Source et méthode',
    methodBody:
      'La racine, la forme du dictionnaire et la grammaire de chaque mot proviennent du Quranic Arabic Corpus (Université de Leeds), où chacun des 77 429 mots a été annoté à la main. Le sens des racines et des mots a été résumé par l’IA à partir du sens mot à mot dans chaque verset ; considère-les comme un repère, pas comme un dictionnaire.',
    source: 'Grammaire : Quranic Arabic Corpus 0.4, Kais Dukes, Université de Leeds (GNU GPL), avec des corrections de mustafa0x/quran-morphology.',
    aiNote: 'Sens résumés par l’IA',
    teaser: 'Presque tous les mots arabes naissent d’une racine de trois lettres. Suis une racine à travers tout le Coran : chaque mot qui en est formé, son sens et tous ses versets.',
    cta: 'Explorer les racines',
  },
  translations: {
    eyebrow: 'Plus de traductions',
    title: 'Les traductions côte à côte',
    hint: 'Le même verset dans plusieurs traductions. Choisis-en une comme base pour voir où les autres traduisent différemment.',
    compareWith: 'Marquer les différences avec',
    compareOff: 'Pas de comparaison',
    isBase: 'base de comparaison',
    alike: '{n} % de mots identiques',
    legendAdded: 'différent',
    legendRemoved: 'omis',
    legendNote: 'Les traductions d’une même langue sont comparées mot à mot.',
    footnote: 'Note {n}',
    notes: 'Notes du traducteur ({n})',
    extra: 'Plus de traductions sous chaque verset',
    extraHint: 'En plus de Korkut et de Saheeh International, depuis QuranEnc.com.',
    lang: { bs: 'Bosniaque', en: 'Anglais', de: 'Deutsch', nl: 'Nederlands', fr: 'Français' },
    names: {
      'bubenheim': 'Bubenheim & Elyas (allemand)',
      'rowwad-de': 'Rowwad (allemand)',
      'rowwad-nl': 'Rowwad (néerlandais)',
      rashid: 'Rachid Maach (français)',
      'noor-fr': 'Noor International (français)',
      korkut: 'Besim Korkut',
      mehanovic: 'Muhamed Mehanović',
      'rowwad-bs': 'Rowwad (bosniaque)',
      saheeh: 'Saheeh International',
      'hilali-khan': 'Hilali & Khan',
      'rowwad-en': 'Rowwad (anglais)',
    },
  },
  chronology: {
    nav: 'Chronologie',
    eyebrow: 'L’ordre de la révélation',
    title: 'Le Coran dans l’ordre de sa révélation',
    subtitle:
      'Le Coran a été révélé progressivement, sur environ 23 ans, et le mushaf ne range pas ses sourates dans cet ordre. Les voici telles qu’elles sont descendues : des premiers versets d’Al-Alaq à La Mecque aux dernières sourates à Médine.',
    factYears: 'années de révélation',
    factMeccan: 'sourates mecquoises',
    factMedinan: 'sourates médinoises',
    timelineTitle: 'Toutes les sourates dans l’ordre de la révélation',
    timelineHint: 'Chaque colonne est une sourate, d’autant plus haute qu’elle compte de mots. Clique sur une colonne pour ouvrir la sourate.',
    timelineInsight:
      'Les premières sourates révélées sont courtes, rythmées et percutantes. Au fil de la révélation, elles s’allongent, et après l’Hégire vers Médine viennent les plus longues, avec les lois d’une communauté.',
    barHint: 'Hauteur = nombre de mots',
    hijra: 'Hégire (622)',
    revealedNth: 'révélée en {n}e position',
    ayahs: 'Versets',
    words: 'Mots',
    ayahCount: '{n} versets',
    chartLabel: 'Diagramme en barres : les 114 sourates dans l’ordre de la révélation ; la hauteur indique le nombre de mots, la couleur la période mecquoise ou médinoise.',
    chartCaption: 'Les sourates, de gauche à droite, dans l’ordre de leur révélation ; la ligne pointillée marque l’Hégire.',
    compareTitle: 'Sourates mecquoises et médinoises',
    compareSubtitle: 'Un seul Coran, deux périodes : treize ans d’appel à La Mecque et dix ans à bâtir une communauté à Médine. La différence se voit aussi dans les chiffres.',
    metric: {
      surahs: 'Sourates',
      ayahs: 'Versets',
      words: 'Mots',
      wordsPerAyah: 'Mots par verset (moyenne)',
      ayahsPerSurah: 'Versets par sourate (moyenne)',
    },
    lengthInsight: 'Un verset mecquois compte {meccan} mots en moyenne, un verset médinois {medinan}. Les versets courts et denses de La Mecque s’allongent et se font plus détaillés à Médine, lorsqu’ils apportent des lois.',
    distinctive: {
      meccan: 'Caractéristiques des sourates mecquoises',
      medinan: 'Caractéristiques des sourates médinoises',
    },
    distinctiveHint: 'Les racines qu’une période emploie bien plus que l’autre. Chiffres : mecquois · médinois.',
    methodNote:
      'Méthode : le rapport des log-cotes avec a priori de Dirichlet informatif (Monroe, Colaresi & Quinn, 2008), exprimé en score z. Il mesure non pas la fréquence d’un mot, mais à quel point il est fréquent de façon inattendue dans une période, et reste prudent avec les mots rares. Racines tirées du Quranic Arabic Corpus.',
    listTitle: 'Les sourates dans l’ordre de la révélation',
    period: { meccan: 'Période mecquoise · 1–86', medinan: 'Période médinoise · 87–114' },
    aboutTitle: 'À propos de l’ordre de la révélation',
    about1:
      'Cet ordre est celui de l’édition égyptienne de référence du mushaf (al-Azhar, 1924), qui s’appuie sur les récits des Compagnons et de leurs élèves. C’est l’ordre le plus souvent cité, mais pas le seul : les savants divergent sur la place de certaines sourates, et certaines sourates contiennent des versets des deux périodes.',
    about2:
      'Les sourates révélées avant l’Hégire sont dites mecquoises et celles d’après médinoises, quel que soit le lieu où le verset a été révélé. Les années sont approximatives : la révélation a commencé vers 610, l’Hégire a eu lieu en 622 et les derniers versets sont venus en 632.',
    source: 'Sources : ordre de la révélation et répartition mecquoise / médinoise, Tanzil Project (tanzil.net, CC BY 3.0) ; mots et racines, Quranic Arabic Corpus 0.4 (corpus.quran.com).',
    teaser: 'Les sourates dans l’ordre de leur révélation, sur une frise chronologique, et ce qui distingue les sourates mecquoises des médinoises : la longueur, le rythme et les mots.',
    cta: 'Ouvrir la chronologie',
    mushafOrder: 'Ordre du mushaf',
    revelationOrder: 'Ordre de la révélation',
    orderLabel: 'Ordre des sourates',
  },
  app: {
    available: 'Gratuit sur',
    eyebrow: 'L’application Deenly',
    title: 'Emporte le Coran avec toi',
    subtitle:
      'Sur le web, tu lis et tu étudies. Dans l’application, le Coran vit avec toi : mémorise avec une IA qui écoute ta récitation, écoute hors ligne et ne perds jamais ta page.',
    features: [
      { icon: 'solar:microphone-3-linear', title: 'Hifz avec l’IA', body: 'Récite à voix haute et chaque mot est marqué juste ou faux.' },
      { icon: 'solar:download-minimalistic-linear', title: 'Audio hors ligne', body: 'Télécharge des sourates et écoute-les partout.' },
      { icon: 'solar:bell-linear', title: 'Rappels', body: 'Un petit mot matin et soir, avec un verset du jour.' },
      { icon: 'solar:cup-star-linear', title: 'Khatm et récompenses', body: 'Un plan de lecture et des étapes qui t’aident à persévérer.' },
    ],
  },
  footer: {
    title: 'Le Coran sur Deenly',
    body: 'Le Coran est ouvert à tous, gratuitement et sans compte. Le texte et les traductions proviennent des sources de confiance indiquées ci-dessous.',
    arabic: 'Texte arabe',
    audio: 'Audio',
    bs: 'Traduction bosniaque',
    en: 'Traduction anglaise',
    links: 'Liens',
  },
};
